import { Enum } from '@/app/model/base/enum'

const values = {
  IN_QUEUE: 1,
  CALLED: 2,
  POSTPONED: 3,
  SERVICING: 4,
  SERVICED: 5
}

class ScreenStateId extends Enum {
  static isInQueue (value) {
    return value === values.IN_QUEUE
  }

  static isCalled (value) {
    return value === values.CALLED
  }

  static isPostponed (value) {
    return value === values.POSTPONED
  }

  static isServicing (value) {
    return value === values.SERVICING
  }

  static isServiced (value) {
    return value === values.SERVICED
  }
}

export default ScreenStateId.initEnum(values)
